import React, { useState } from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import './Slider.scss'

function Slider() {
    const [currentSlide,setCurrentSlide] = useState(0);

    const prevSlide=()=>{
        setCurrentSlide(currentSlide === 0 ? 2 : (prev) => prev - 1 )

    }

    const nextSlide=()=>{
        setCurrentSlide(currentSlide === 2 ? 0 : (prev) => prev + 1 )

    }

    const data = [
        'https://wallpapercave.com/wp/qsB1iYk.jpg',
        'https://wallpapercave.com/wp/mtaUQaL.jpg',
        'http://rebekkabruggner.com/wp-content/uploads/2014/09/fashion_04_DSC9606_B.jpg'    ]
  return (
    <div className='slider' style={{transform:`translateX(-${currentSlide * 100}vw)`}}>
        <div className="container">
        <img src={data[0]} alt="" />
        <img src={data[1]} alt="" />
        <img src={data[2]} alt="" />
        </div>
        <div className="icons">
            <div className="icon" onClick={prevSlide}>
                <ArrowBackIcon/>
            </div>
            <div className="icon" onClick={nextSlide}>
                <ArrowForwardIcon/>
            </div>
        </div>
        
    </div>
  )
}

export default Slider
